import React, {useEffect, useState} from 'react';

export const useWindowSize = () => {
  const isClient = typeof window === 'object';
  const [isFirsTime, setIsFirsTime] = useState(true);

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }
    
    function handleResize() {
      setWindowSize(getSize());
    }

    if(isFirsTime){
      handleResize()
      setIsFirsTime(false)
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}